if (!customElements.get('cross-sell-recommendations')) {
    customElements.define('cross-sell-recommendations', class extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();

        const productId = this.dataset.productId;
        if (!productId) return;

        const cartIds = (this.dataset.cartIds || '')
          .split(',')
          .map(id => id.trim())
          .filter(Boolean);
        const limit = parseInt(this.dataset.limit, 10) || 4;
        const localeMatch = window.location.pathname.match(/^\/(en-gb|en-us|en-eu|en)/);
        const locale = localeMatch ? localeMatch[1] : 'en-gb';
        const url =
          `/${locale}/recommendations/products?section_id=cart-cross-sell-recommendations` +
          `&product_id=${productId}&limit=${limit}&intent=related`;

        fetch(url, { signal: this._abort.signal })
          .then(res => {
            if (!res.ok) throw new Error(`Recommendations request failed (${res.status})`);
            return res.text();
          })
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return Array.from(doc.querySelectorAll('[data-swiper-slide]')).filter(
              slide => !cartIds.includes(slide.dataset.blockId)
            );
          })
          .then(slides => {
            if (!slides.length) return;

            if (slides.length === 1) {
              this._renderSingle(slides[0]);
            } else {
              return Promise.race([
                customElements.whenDefined('slideshow-section'),
                new Promise(resolve => setTimeout(resolve, 3000)),
              ]).then(() => this._renderSlider(slides));
            }
          })
          .catch(err => {
            if (err.name !== 'AbortError') {
              console.warn('[cross-sell-recommendations]', err);
            }
          });
      }

      disconnectedCallback() {
        this._abort?.abort();
      }

      _renderSingle(slide) {
        const card = slide.querySelector('.shoppable-product-card');
        const productsContainer = this.querySelector('[data-cross-sell-products]');
        if (card) {
          card.classList.add('shoppable-product-card--full');
          productsContainer.innerHTML = '';
          productsContainer.appendChild(card);
        } else {
          productsContainer.innerHTML = '';
          productsContainer.appendChild(slide);
        }
        productsContainer.style.display = '';
      }

      _renderSlider(slides) {
        const existingSlideshow = this.querySelector('slideshow-section');
        if (!existingSlideshow) return;

        const freshSlideshow = existingSlideshow.cloneNode(true);
        const swiperContainer = freshSlideshow.querySelector('[data-swiper-container]');
        slides.forEach(slide => swiperContainer.appendChild(slide));
        existingSlideshow.parentNode.replaceChild(freshSlideshow, existingSlideshow);

        this.querySelector('[data-cross-sell-products]').style.display = '';
      }
    });
  }